import { useMemo } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AutocompleteElement } from 'components/muiInputWrappers';
import useGetAllServiceTypes from 'hooks/catalog/useGetAllServiceTypes';
import useGetAllServiceClass from 'pages/Admin/Cataloges/ServiceType/services/useGetServiceClass';

export type FormFields = {
  serviceTypeId?: number;
  serviceClassId?: number;
};

type Props = {
  form: UseFormReturn<FormFields, FormFields>;
};

function ServiceTypeSearch({ form }: Props) {
  const { allServiceTypes, isAllServiceTypesLoading } = useGetAllServiceTypes();

  const { data: serviceClass, isLoading: isLoadingServiceClass } =
    useGetAllServiceClass({
      id: form.getValues('serviceTypeId')
    });

  const { t } = useTranslation('global');

  const allPartnersOptions = useMemo(
    () =>
      allServiceTypes
        ? allServiceTypes?.map((serviceType) => ({
            label: serviceType.name,
            id: serviceType.id
          }))
        : [],
    [allServiceTypes]
  );

  return (
    <Box
      data-testid="ticket-accordion-content"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
      }}
    >
      <Grid data-testid="service-type-autocomplete">
        <Typography>{t('common.commonProperties.serviceType')}</Typography>
        <AutocompleteElement
          autocompleteProps={{
            size: 'small'
          }}
          control={form?.control}
          loading={isAllServiceTypesLoading}
          name="serviceTypeId"
          options={allPartnersOptions}
          rules={{
            minLength: {
              value: 1,
              message: t('ticket.messages.valueLessThan1')
            },
            maxLength: {
              value: 30,
              message: t('ticket.messages.valueLongerThan30')
            }
          }}
          matchId
        />
      </Grid>
      <Grid width="100%" item>
        <Typography>
          {t('admin.catalogs.serviceType.columnServiceClass')}
        </Typography>
        <AutocompleteElement
          autocompleteProps={{
            size: 'small'
          }}
          control={form.control}
          loading={isLoadingServiceClass}
          name="serviceClassId"
          options={serviceClass?.map((item) => ({
            id: item?.id,
            label: item?.name
          }))}
          matchId
        />
      </Grid>
    </Box>
  );
}

export default ServiceTypeSearch;
